
import verifyManager from '@shein-risk/si_verify'
import { API_URL, ICON_TYPES, LLBS_COOKIE_NAME } from '@/constants';
import { fetchWithRetries } from '@/utils';
import { setCookie } from '@/utils/setCookie';

export default (data: any) => {
    return new Promise((resolve, reject) => {
        const { keep_store = true, baseURL, site_id, site_from, language, headers = {}, validate_type, validate_scene, validate_channel, validate_param, cookie_duration = 0 } = data
        verifyManager.init({
            baseURL,
            headers: () => headers,
            data: () => {
                return { site_id, site_from, language }
            }
        })
        const options = {
            validate_type: ICON_TYPES[validate_type],
            validate_scene,
            validate_channel,
            validate_param
        }

        const callback = async (data) => {
            const { isSuccess } = data
            if (isSuccess) {
                const params = {
                    challenge: '',
                    captcha_type: validate_type,
                    gRisk: '',
                    validate_scene,
                    validate_token: data?.info?.validate_token || '',
                    validate_channel
                }
                const d = await fetchWithRetries(`${baseURL}${API_URL.VALIDATION_ANTI_FLOW_CHECK}`, {
                    method: 'POST',
                    body: JSON.stringify(params),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(response => response.json()).catch(err => err)
                const risk_response = {
                    status: d.status == 0 ? 'success' : 'risk_error',
                    code: d.status,
                    llbs: d.llbs || ''
                }
                if (d.status == 0) {
                    if (keep_store) {
                        // 设置流量层挑战豁免cookie，有效期为网关拦截时间(cookie_duration)的2倍，防止正常用户的有效期小于网关设置的有效期
                        const timeout = parseInt(cookie_duration) || 0
                        setCookie({ key: LLBS_COOKIE_NAME, value: d.llbs, end: timeout * 2 })
                    }
                }
                resolve(risk_response)
            } else {
                resolve(data)
            }
        }
        verifyManager.doVerify(options, callback).catch(data => {
            reject(data)
        })
    })
};
